enum Blockchain {
  UNKNOWN = 'unknown',
  SOLANA = 'solana',
  ETHEREUM = 'ethereum',
}

export default Blockchain;
